// extracted by mini-css-extract-plugin
export var card = "index-module--card--CbziY";
export var logo = "index-module--logo--3XbRA";
export var underscore = "index-module--underscore--3OIQP";
export var one = "index-module--one--3DZPy";
export var pages = "index-module--pages--3wpY5";